import { Route } from '@angular/router';
import { marketReportResolver } from './data-access/market-report-resolver.service';
import { MarketReportComponent } from './feat-market-report/market-report.component';

export const marketReportRoutes: Route[] = [
  {
    path: '',
    component: MarketReportComponent,
    resolve: {
      report: marketReportResolver,
    },
  },
];
